// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AddTicketMessageData, AddTicketMessageErrors, AddTicketMessageResponses, CancelAccountDeletionData, CancelAccountDeletionErrors, CancelAccountDeletionResponses, ChangePasswordData, ChangePasswordErrors, ChangePasswordResponses, ConfirmEmailData, ConfirmEmailErrors, ConfirmEmailResponses, ConfirmMfaEnrollmentData, ConfirmMfaEnrollmentErrors, ConfirmMfaEnrollmentResponses, CreateTicketData, CreateTicketErrors, CreateTicketResponses, DeleteItemAttachmentData, DeleteItemAttachmentErrors, DeleteItemAttachmentResponses, DeleteItemData, DeleteItemErrors, DeleteItemReminderData, DeleteItemReminderErrors, DeleteItemReminderResponses, DeleteItemResponses, DeleteKitData, DeleteKitErrors, DeleteKitResponses, DeleteUploadData, DeleteUploadErrors, DeleteUploadResponses, DisableMfaData, DisableMfaErrors, DisableMfaResponses, EnrollMfaData, EnrollMfaErrors, EnrollMfaResponses, ExportAccountData, ExportAccountErrors, ExportAccountResponses, ForgotPasswordData, ForgotPasswordErrors, ForgotPasswordResponses, GetAccountDeletionData, GetAccountDeletionErrors, GetAccountDeletionResponses, GetHealthData, GetHealthErrors, GetHealthResponses, GetItemAttachmentData, GetItemAttachmentErrors, GetItemAttachmentResponses, GetItemData, GetItemErrors, GetItemReminderData, GetItemReminderErrors, GetItemReminderResponses, GetItemResponses, GetKitData, GetKitErrors, GetKitResponses, GetMeData, GetMeErrors, GetMeResponses, GetTicketData, GetTicketErrors, GetTicketResponses, GetUploadUrlData, GetUploadUrlErrors, GetUploadUrlResponses, ListItemAttachmentsData, ListItemAttachmentsErrors, ListItemAttachmentsResponses, ListItemRemindersData, ListItemRemindersErrors, ListItemRemindersResponses, ListItemsData, ListItemsErrors, ListItemsResponses, ListKitsData, ListKitsErrors, ListKitsResponses, ListTicketsData, ListTicketsErrors, ListTicketsResponses, PatchItemAttachmentData, PatchItemAttachmentErrors, PatchItemAttachmentResponses, PatchItemData, PatchItemErrors, PatchItemReminderData, PatchItemReminderErrors, PatchItemReminderResponses, PatchItemResponses, PatchKitData, PatchKitErrors, PatchKitResponses, PutItemAttachmentData, PutItemAttachmentErrors, PutItemAttachmentResponses, PutItemData, PutItemErrors, PutItemReminderData, PutItemReminderErrors, PutItemReminderResponses, PutItemResponses, PutKitData, PutKitErrors, PutKitResponses, RefreshSessionData, RefreshSessionErrors, RefreshSessionResponses, RegisterDevicePushTokenData, RegisterDevicePushTokenErrors, RegisterDevicePushTokenResponses, RequestAccountDeletionData, RequestAccountDeletionErrors, RequestAccountDeletionResponses, RequestMagicLinkData, RequestMagicLinkErrors, RequestMagicLinkResponses, ResendConfirmationData, ResendConfirmationErrors, ResendConfirmationResponses, ResetPasswordData, ResetPasswordErrors, ResetPasswordResponses, RevenueCatWebhookData, RevenueCatWebhookErrors, RevenueCatWebhookResponses, SetTicketStatusData, SetTicketStatusErrors, SetTicketStatusResponses, SignInData, SignInErrors, SignInResponses, SignOutData, SignOutErrors, SignOutResponses, SignUpData, SignUpErrors, SignUpResponses, SubmitContactData, SubmitContactErrors, SubmitContactResponses, SubmitFeedbackData, SubmitFeedbackErrors, SubmitFeedbackResponses, UpdateMeData, UpdateMeErrors, UpdateMeResponses, VerifyMagicLinkData, VerifyMagicLinkErrors, VerifyMagicLinkResponses, VerifyMfaData, VerifyMfaErrors, VerifyMfaResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Cancel a scheduled deletion
 */
export const cancelAccountDeletion = <ThrowOnError extends boolean = false>(options?: Options<CancelAccountDeletionData, ThrowOnError>): RequestResult<CancelAccountDeletionResponses, CancelAccountDeletionErrors, ThrowOnError> => (options?.client ?? client).delete<CancelAccountDeletionResponses, CancelAccountDeletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/deletion',
    ...options
});

/**
 * Current deletion request, if any
 */
export const getAccountDeletion = <ThrowOnError extends boolean = false>(options?: Options<GetAccountDeletionData, ThrowOnError>): RequestResult<GetAccountDeletionResponses, GetAccountDeletionErrors, ThrowOnError> => (options?.client ?? client).get<GetAccountDeletionResponses, GetAccountDeletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/deletion',
    ...options
});

/**
 * Schedule the account for deletion
 */
export const requestAccountDeletion = <ThrowOnError extends boolean = false>(options: Options<RequestAccountDeletionData, ThrowOnError>): RequestResult<RequestAccountDeletionResponses, RequestAccountDeletionErrors, ThrowOnError> => (options.client ?? client).post<RequestAccountDeletionResponses, RequestAccountDeletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/deletion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export all of the user's data
 */
export const exportAccount = <ThrowOnError extends boolean = false>(options?: Options<ExportAccountData, ThrowOnError>): RequestResult<ExportAccountResponses, ExportAccountErrors, ThrowOnError> => (options?.client ?? client).get<ExportAccountResponses, ExportAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/export',
    ...options
});

/**
 * Confirm an email address
 */
export const confirmEmail = <ThrowOnError extends boolean = false>(options: Options<ConfirmEmailData, ThrowOnError>): RequestResult<ConfirmEmailResponses, ConfirmEmailErrors, ThrowOnError> => (options.client ?? client).post<ConfirmEmailResponses, ConfirmEmailErrors, ThrowOnError>({
    url: '/v1/auth/email/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend the confirmation email
 */
export const resendConfirmation = <ThrowOnError extends boolean = false>(options: Options<ResendConfirmationData, ThrowOnError>): RequestResult<ResendConfirmationResponses, ResendConfirmationErrors, ThrowOnError> => (options.client ?? client).post<ResendConfirmationResponses, ResendConfirmationErrors, ThrowOnError>({
    url: '/v1/auth/email/resend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The signed-in user
 */
export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>): RequestResult<GetMeResponses, GetMeErrors, ThrowOnError> => (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/me',
    ...options
});

/**
 * Update the signed-in user
 */
export const updateMe = <ThrowOnError extends boolean = false>(options: Options<UpdateMeData, ThrowOnError>): RequestResult<UpdateMeResponses, UpdateMeErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMeResponses, UpdateMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Turn off two-factor authentication (needs an MFA-verified session)
 */
export const disableMfa = <ThrowOnError extends boolean = false>(options?: Options<DisableMfaData, ThrowOnError>): RequestResult<DisableMfaResponses, DisableMfaErrors, ThrowOnError> => (options?.client ?? client).post<DisableMfaResponses, DisableMfaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/mfa/disable',
    ...options
});

/**
 * Begin two-factor enrolment
 */
export const enrollMfa = <ThrowOnError extends boolean = false>(options?: Options<EnrollMfaData, ThrowOnError>): RequestResult<EnrollMfaResponses, EnrollMfaErrors, ThrowOnError> => (options?.client ?? client).post<EnrollMfaResponses, EnrollMfaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/mfa/enroll',
    ...options
});

/**
 * Confirm enrolment with a code
 */
export const confirmMfaEnrollment = <ThrowOnError extends boolean = false>(options: Options<ConfirmMfaEnrollmentData, ThrowOnError>): RequestResult<ConfirmMfaEnrollmentResponses, ConfirmMfaEnrollmentErrors, ThrowOnError> => (options.client ?? client).post<ConfirmMfaEnrollmentResponses, ConfirmMfaEnrollmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/mfa/enroll/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Finish a two-factor sign-in
 */
export const verifyMfa = <ThrowOnError extends boolean = false>(options: Options<VerifyMfaData, ThrowOnError>): RequestResult<VerifyMfaResponses, VerifyMfaErrors, ThrowOnError> => (options.client ?? client).post<VerifyMfaResponses, VerifyMfaErrors, ThrowOnError>({
    url: '/v1/auth/mfa/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email a sign-in link
 */
export const requestMagicLink = <ThrowOnError extends boolean = false>(options: Options<RequestMagicLinkData, ThrowOnError>): RequestResult<RequestMagicLinkResponses, RequestMagicLinkErrors, ThrowOnError> => (options.client ?? client).post<RequestMagicLinkResponses, RequestMagicLinkErrors, ThrowOnError>({
    url: '/v1/auth/otp/request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign in with an emailed token
 */
export const verifyMagicLink = <ThrowOnError extends boolean = false>(options: Options<VerifyMagicLinkData, ThrowOnError>): RequestResult<VerifyMagicLinkResponses, VerifyMagicLinkErrors, ThrowOnError> => (options.client ?? client).post<VerifyMagicLinkResponses, VerifyMagicLinkErrors, ThrowOnError>({
    url: '/v1/auth/otp/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change password
 */
export const changePassword = <ThrowOnError extends boolean = false>(options: Options<ChangePasswordData, ThrowOnError>): RequestResult<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError> => (options.client ?? client).post<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/password/change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email a password reset link
 */
export const forgotPassword = <ThrowOnError extends boolean = false>(options: Options<ForgotPasswordData, ThrowOnError>): RequestResult<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError> => (options.client ?? client).post<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError>({
    url: '/v1/auth/password/forgot',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set a new password using an emailed token
 */
export const resetPassword = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordData, ThrowOnError>): RequestResult<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError> => (options.client ?? client).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
    url: '/v1/auth/password/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rotate the refresh token
 */
export const refreshSession = <ThrowOnError extends boolean = false>(options: Options<RefreshSessionData, ThrowOnError>): RequestResult<RefreshSessionResponses, RefreshSessionErrors, ThrowOnError> => (options.client ?? client).post<RefreshSessionResponses, RefreshSessionErrors, ThrowOnError>({
    url: '/v1/auth/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign in with email and password
 */
export const signIn = <ThrowOnError extends boolean = false>(options: Options<SignInData, ThrowOnError>): RequestResult<SignInResponses, SignInErrors, ThrowOnError> => (options.client ?? client).post<SignInResponses, SignInErrors, ThrowOnError>({
    url: '/v1/auth/sign-in',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke the current session
 */
export const signOut = <ThrowOnError extends boolean = false>(options?: Options<SignOutData, ThrowOnError>): RequestResult<SignOutResponses, SignOutErrors, ThrowOnError> => (options?.client ?? client).post<SignOutResponses, SignOutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/sign-out',
    ...options
});

/**
 * Create an account
 */
export const signUp = <ThrowOnError extends boolean = false>(options: Options<SignUpData, ThrowOnError>): RequestResult<SignUpResponses, SignUpErrors, ThrowOnError> => (options.client ?? client).post<SignUpResponses, SignUpErrors, ThrowOnError>({
    url: '/v1/auth/sign-up',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send a contact message
 */
export const submitContact = <ThrowOnError extends boolean = false>(options: Options<SubmitContactData, ThrowOnError>): RequestResult<SubmitContactResponses, SubmitContactErrors, ThrowOnError> => (options.client ?? client).post<SubmitContactResponses, SubmitContactErrors, ThrowOnError>({
    url: '/v1/contact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register this device for push notifications
 */
export const registerDevicePushToken = <ThrowOnError extends boolean = false>(options: Options<RegisterDevicePushTokenData, ThrowOnError>): RequestResult<RegisterDevicePushTokenResponses, RegisterDevicePushTokenErrors, ThrowOnError> => (options.client ?? client).put<RegisterDevicePushTokenResponses, RegisterDevicePushTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/device-push-tokens',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send feedback
 */
export const submitFeedback = <ThrowOnError extends boolean = false>(options: Options<SubmitFeedbackData, ThrowOnError>): RequestResult<SubmitFeedbackResponses, SubmitFeedbackErrors, ThrowOnError> => (options.client ?? client).post<SubmitFeedbackResponses, SubmitFeedbackErrors, ThrowOnError>({
    url: '/v1/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Liveness and database check
 */
export const getHealth = <ThrowOnError extends boolean = false>(options?: Options<GetHealthData, ThrowOnError>): RequestResult<GetHealthResponses, GetHealthErrors, ThrowOnError> => (options?.client ?? client).get<GetHealthResponses, GetHealthErrors, ThrowOnError>({ url: '/v1/health', ...options });

/**
 * List ItemAttachment rows (delta sync)
 */
export const listItemAttachments = <ThrowOnError extends boolean = false>(options?: Options<ListItemAttachmentsData, ThrowOnError>): RequestResult<ListItemAttachmentsResponses, ListItemAttachmentsErrors, ThrowOnError> => (options?.client ?? client).get<ListItemAttachmentsResponses, ListItemAttachmentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/item-attachments',
    ...options
});

/**
 * Delete a ItemAttachment (soft by default)
 */
export const deleteItemAttachment = <ThrowOnError extends boolean = false>(options: Options<DeleteItemAttachmentData, ThrowOnError>): RequestResult<DeleteItemAttachmentResponses, DeleteItemAttachmentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteItemAttachmentResponses, DeleteItemAttachmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/item-attachments/{id}',
    ...options
});

/**
 * Get one ItemAttachment
 */
export const getItemAttachment = <ThrowOnError extends boolean = false>(options: Options<GetItemAttachmentData, ThrowOnError>): RequestResult<GetItemAttachmentResponses, GetItemAttachmentErrors, ThrowOnError> => (options.client ?? client).get<GetItemAttachmentResponses, GetItemAttachmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/item-attachments/{id}',
    ...options
});

/**
 * Update fields of a ItemAttachment
 */
export const patchItemAttachment = <ThrowOnError extends boolean = false>(options: Options<PatchItemAttachmentData, ThrowOnError>): RequestResult<PatchItemAttachmentResponses, PatchItemAttachmentErrors, ThrowOnError> => (options.client ?? client).patch<PatchItemAttachmentResponses, PatchItemAttachmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/item-attachments/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update a ItemAttachment (idempotent)
 */
export const putItemAttachment = <ThrowOnError extends boolean = false>(options: Options<PutItemAttachmentData, ThrowOnError>): RequestResult<PutItemAttachmentResponses, PutItemAttachmentErrors, ThrowOnError> => (options.client ?? client).put<PutItemAttachmentResponses, PutItemAttachmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/item-attachments/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List ItemReminder rows (delta sync)
 */
export const listItemReminders = <ThrowOnError extends boolean = false>(options?: Options<ListItemRemindersData, ThrowOnError>): RequestResult<ListItemRemindersResponses, ListItemRemindersErrors, ThrowOnError> => (options?.client ?? client).get<ListItemRemindersResponses, ListItemRemindersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/item-reminders',
    ...options
});

/**
 * Delete a ItemReminder (soft by default)
 */
export const deleteItemReminder = <ThrowOnError extends boolean = false>(options: Options<DeleteItemReminderData, ThrowOnError>): RequestResult<DeleteItemReminderResponses, DeleteItemReminderErrors, ThrowOnError> => (options.client ?? client).delete<DeleteItemReminderResponses, DeleteItemReminderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/item-reminders/{id}',
    ...options
});

/**
 * Get one ItemReminder
 */
export const getItemReminder = <ThrowOnError extends boolean = false>(options: Options<GetItemReminderData, ThrowOnError>): RequestResult<GetItemReminderResponses, GetItemReminderErrors, ThrowOnError> => (options.client ?? client).get<GetItemReminderResponses, GetItemReminderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/item-reminders/{id}',
    ...options
});

/**
 * Update fields of a ItemReminder
 */
export const patchItemReminder = <ThrowOnError extends boolean = false>(options: Options<PatchItemReminderData, ThrowOnError>): RequestResult<PatchItemReminderResponses, PatchItemReminderErrors, ThrowOnError> => (options.client ?? client).patch<PatchItemReminderResponses, PatchItemReminderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/item-reminders/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update a ItemReminder (idempotent)
 */
export const putItemReminder = <ThrowOnError extends boolean = false>(options: Options<PutItemReminderData, ThrowOnError>): RequestResult<PutItemReminderResponses, PutItemReminderErrors, ThrowOnError> => (options.client ?? client).put<PutItemReminderResponses, PutItemReminderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/item-reminders/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Item rows (delta sync)
 */
export const listItems = <ThrowOnError extends boolean = false>(options?: Options<ListItemsData, ThrowOnError>): RequestResult<ListItemsResponses, ListItemsErrors, ThrowOnError> => (options?.client ?? client).get<ListItemsResponses, ListItemsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/items',
    ...options
});

/**
 * Delete a Item (soft by default)
 */
export const deleteItem = <ThrowOnError extends boolean = false>(options: Options<DeleteItemData, ThrowOnError>): RequestResult<DeleteItemResponses, DeleteItemErrors, ThrowOnError> => (options.client ?? client).delete<DeleteItemResponses, DeleteItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/items/{id}',
    ...options
});

/**
 * Get one Item
 */
export const getItem = <ThrowOnError extends boolean = false>(options: Options<GetItemData, ThrowOnError>): RequestResult<GetItemResponses, GetItemErrors, ThrowOnError> => (options.client ?? client).get<GetItemResponses, GetItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/items/{id}',
    ...options
});

/**
 * Update fields of a Item
 */
export const patchItem = <ThrowOnError extends boolean = false>(options: Options<PatchItemData, ThrowOnError>): RequestResult<PatchItemResponses, PatchItemErrors, ThrowOnError> => (options.client ?? client).patch<PatchItemResponses, PatchItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/items/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update a Item (idempotent)
 */
export const putItem = <ThrowOnError extends boolean = false>(options: Options<PutItemData, ThrowOnError>): RequestResult<PutItemResponses, PutItemErrors, ThrowOnError> => (options.client ?? client).put<PutItemResponses, PutItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/items/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Kit rows (delta sync)
 */
export const listKits = <ThrowOnError extends boolean = false>(options?: Options<ListKitsData, ThrowOnError>): RequestResult<ListKitsResponses, ListKitsErrors, ThrowOnError> => (options?.client ?? client).get<ListKitsResponses, ListKitsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/kits',
    ...options
});

/**
 * Delete a Kit (soft by default)
 */
export const deleteKit = <ThrowOnError extends boolean = false>(options: Options<DeleteKitData, ThrowOnError>): RequestResult<DeleteKitResponses, DeleteKitErrors, ThrowOnError> => (options.client ?? client).delete<DeleteKitResponses, DeleteKitErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/kits/{id}',
    ...options
});

/**
 * Get one Kit
 */
export const getKit = <ThrowOnError extends boolean = false>(options: Options<GetKitData, ThrowOnError>): RequestResult<GetKitResponses, GetKitErrors, ThrowOnError> => (options.client ?? client).get<GetKitResponses, GetKitErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/kits/{id}',
    ...options
});

/**
 * Update fields of a Kit
 */
export const patchKit = <ThrowOnError extends boolean = false>(options: Options<PatchKitData, ThrowOnError>): RequestResult<PatchKitResponses, PatchKitErrors, ThrowOnError> => (options.client ?? client).patch<PatchKitResponses, PatchKitErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/kits/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update a Kit (idempotent)
 */
export const putKit = <ThrowOnError extends boolean = false>(options: Options<PutKitData, ThrowOnError>): RequestResult<PutKitResponses, PutKitErrors, ThrowOnError> => (options.client ?? client).put<PutKitResponses, PutKitErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/kits/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List my tickets
 */
export const listTickets = <ThrowOnError extends boolean = false>(options?: Options<ListTicketsData, ThrowOnError>): RequestResult<ListTicketsResponses, ListTicketsErrors, ThrowOnError> => (options?.client ?? client).get<ListTicketsResponses, ListTicketsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets',
    ...options
});

/**
 * Open a ticket
 */
export const createTicket = <ThrowOnError extends boolean = false>(options: Options<CreateTicketData, ThrowOnError>): RequestResult<CreateTicketResponses, CreateTicketErrors, ThrowOnError> => (options.client ?? client).post<CreateTicketResponses, CreateTicketErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One of my tickets with its conversation
 */
export const getTicket = <ThrowOnError extends boolean = false>(options: Options<GetTicketData, ThrowOnError>): RequestResult<GetTicketResponses, GetTicketErrors, ThrowOnError> => (options.client ?? client).get<GetTicketResponses, GetTicketErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets/{id}',
    ...options
});

/**
 * Add a note to a ticket
 */
export const addTicketMessage = <ThrowOnError extends boolean = false>(options: Options<AddTicketMessageData, ThrowOnError>): RequestResult<AddTicketMessageResponses, AddTicketMessageErrors, ThrowOnError> => (options.client ?? client).post<AddTicketMessageResponses, AddTicketMessageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets/{id}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Close or reopen a ticket
 */
export const setTicketStatus = <ThrowOnError extends boolean = false>(options: Options<SetTicketStatusData, ThrowOnError>): RequestResult<SetTicketStatusResponses, SetTicketStatusErrors, ThrowOnError> => (options.client ?? client).post<SetTicketStatusResponses, SetTicketStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets/{id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an uploaded file
 */
export const deleteUpload = <ThrowOnError extends boolean = false>(options: Options<DeleteUploadData, ThrowOnError>): RequestResult<DeleteUploadResponses, DeleteUploadErrors, ThrowOnError> => (options.client ?? client).delete<DeleteUploadResponses, DeleteUploadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/uploads',
    ...options
});

/**
 * A short-lived signed URL for an uploaded file
 */
export const getUploadUrl = <ThrowOnError extends boolean = false>(options: Options<GetUploadUrlData, ThrowOnError>): RequestResult<GetUploadUrlResponses, GetUploadUrlErrors, ThrowOnError> => (options.client ?? client).get<GetUploadUrlResponses, GetUploadUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/uploads/url',
    ...options
});

/**
 * RevenueCat server-to-server event
 */
export const revenueCatWebhook = <ThrowOnError extends boolean = false>(options: Options<RevenueCatWebhookData, ThrowOnError>): RequestResult<RevenueCatWebhookResponses, RevenueCatWebhookErrors, ThrowOnError> => (options.client ?? client).post<RevenueCatWebhookResponses, RevenueCatWebhookErrors, ThrowOnError>({
    url: '/v1/webhooks/revenuecat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
